
export default function Benefits() {
  const benefits = [
    {
      icon: 'ri-speed-fill',
      title: 'Evaluación Rápida',
      description: 'Respuesta preliminar en 24-48 horas con análisis profesional de tu perfil crediticio'
    },
    {
      icon: 'ri-lock-password-fill',
      title: 'Confidencialidad Total',
      description: 'Protección de datos con cifrado de nivel bancario y cumplimiento de normativas internacionales'
    },
    {
      icon: 'ri-user-star-fill',
      title: 'Asesoría Personalizada',
      description: 'Ejecutivos especializados que te acompañan en cada etapa del proceso de financiamiento'
    },
    {
      icon: 'ri-file-shield-fill',
      title: 'Transparencia Absoluta',
      description: 'Información clara sobre tasas, comisiones y condiciones sin costos ocultos'
    },
    {
      icon: 'ri-smartphone-fill',
      title: 'Proceso 100% Digital',
      description: 'Solicita, firma y recibe tu crédito completamente en línea desde cualquier dispositivo'
    },
    {
      icon: 'ri-customer-service-fill',
      title: 'Soporte Continuo',
      description: 'Atención profesional disponible en horario extendido para resolver tus consultas'
    },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-800 mb-4">
            ¿Por Qué Elegir Novacréditos?
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Compromiso con la excelencia en servicios financieros y atención al cliente
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div key={index} className="bg-slate-50 rounded-xl p-8 hover:shadow-lg transition-shadow group">
              <div className="w-14 h-14 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-lg flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <i className={`${benefit.icon} text-white text-2xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-slate-800 mb-3">{benefit.title}</h3>
              <p className="text-slate-600 leading-relaxed">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
